/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IFilterField } from "Interfaces/IFilterField";
import { IKeyText } from "Interfaces/IKeyText";

import { fieldTypes } from "./FilterFields";

export const defaultListingPageSize = 16;

const EXPEDITED = "expedited";

/**
 * Dropdown options for the provisioned selector
 */
export const expeditedOptions: IKeyText[] = [
  {
    key: "true",
    text: "Yes",
  },
  {
    key: "false",
    text: "No",
  },
];

/**
 * Sidebar filter constants used for
 * visual studio benefits filtering.
 */
export const azureBenefitRequestsFilterFields: IFilterField[] = [
  {
    key: EXPEDITED,
    text: "Expedited",
    type: fieldTypes.EXPEDITED,
    options: expeditedOptions,
  },
];

/**
 * Default filter values for the azure benefit requests.
 */
export const defaultFilterValues: {
  fieldName: string;
  value: string;
}[] = [];
